module.exports = __webpack_public_path__ + "media/vendor-signup-video-cover.84687167.png";